import React, { useContext } from "react";
import { FooterContext } from "../../../../store/context/footer-context";
import useLocalization from "../../../../hooks/useLocalization";
import { getTrueClasses } from "../../../../helpers";
import US from "./US";
import EU from "./EU";
import "./index.scss";

const Bottom = () => {
  const { language } = useContext(FooterContext);
  const currentLocale = useLocalization() || "us";
  const LOCALIZATION_SWITCH = process.env.LOCALIZATION_SWITCH === "true";

  const isShowAddresses =
    LOCALIZATION_SWITCH &&
    ((currentLocale === "eu" && language === "en") || language === "de");

  return (
    <div className={getTrueClasses("GCL-F-B", isShowAddresses && "GCL-F-B_eu")}>
      <US />
      {isShowAddresses && <EU />}
    </div>
  );
};
export default Bottom;
